export default "__VITE_ASSET__e7bc1f89__"